
import * as angular from 'angular';
import { IValueViewModel, IdentifierType, AggregationMode, SelectionStrategy, ComponentDefinition } from '../../models/';

enum ViewModelType {
    None,
    Tag,
    Identifier
}

class ValueViewModelDisplayController implements angular.IComponentController {
    isEditMode: boolean;
    linkedViewModel: IValueViewModel;
    viewModel: IValueViewModel;
    viewModelType: ViewModelType = ViewModelType.None;

    static $inject = [];

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj.viewModel && changesObj.viewModel.currentValue) {
            switch (this.viewModel.identifierType) {
                case IdentifierType.Tag:
                    this.viewModelType = ViewModelType.Tag;
                    break;
                case IdentifierType.CalculatedValue:
                    this.viewModelType = this.viewModel.aggregationMode === AggregationMode.None ? ViewModelType.None : ViewModelType.Identifier;
                    break;
                case IdentifierType.Linked:
                    this.viewModelType = ViewModelType.Identifier;
                    break;
                case IdentifierType.Validated:
                    switch (this.viewModel.selectionStrategy) {
                        case SelectionStrategy.Tags:
                            this.viewModelType = ViewModelType.Tag;
                            break;
                        case SelectionStrategy.Calculated:
                            this.viewModelType = ViewModelType.Identifier;
                            break;
                    }
                    break;
                case IdentifierType.Target:
                    switch (this.viewModel.selectionStrategy) {
                        case SelectionStrategy.Tags:
                            this.viewModelType = ViewModelType.Tag;
                            break;
                        case SelectionStrategy.Calculated:
                            this.viewModelType = ViewModelType.Identifier;
                            break;
                    }
                    break;
            }
        }
    }
}

export const wtValueViewModelDisplay: ComponentDefinition = {
    componentId: 'wtValueViewModelDisplay',
    controller: ValueViewModelDisplayController,
    template: require('./valueViewModelDisplay.component.html'),
    controllerAs: 'vm',
    bindings: {
        viewModel: '<',
        isEditMode: '<?',
        linkedViewModel: '<'
    }
};
